import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnding = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			rx: 13,
			fill: "#FDECEC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.25 10V13.75L15.4375 15.64L16.015 14.68L13.375 13.1125V10H12.25ZM19.75 11.5V6.25L17.77 8.23C16.555 7.0075 14.8675 6.25 13 6.25C9.2725 6.25 6.25 9.2725 6.25 13C6.25 16.7275 9.2725 19.75 13 19.75C16.7275 19.75 19.75 16.7275 19.75 13H18.25C18.25 15.895 15.895 18.25 13 18.25C10.105 18.25 7.75 15.895 7.75 13C7.75 10.105 10.105 7.75 13 7.75C14.4475 7.75 15.76 8.3425 16.7125 9.2875L14.5 11.5H19.75Z",
			fill: "#D32F2F"
		})
	]
});
const ForwardRef = forwardRef(SvgEnding);
export default ForwardRef;
